import cn from "classnames";
import BookShow from "components/shared/book/show";
import { getInitialStateFromConfig, serializeReq } from "helpers/form";
import { viewContainer } from "helpers/redux";
import { requiredField } from "helpers/validators";
import React from "react";
import { list as logistsList } from "sources/books/employees";

const config = {
    logistId: {
        label: "Логист",
        url: logistsList,
        inputProps: { name: "logistId" },
        propName: "fullNameOrEmail",
        validators: [requiredField],
        required: true,
    },
    startedAt: {
        label: "Дата привязки",
        inputProps: { name: "startedAt" },
        validators: [requiredField],
        required: true,
    },
    endedAt: {
        label: "Дата отвязки",
        inputProps: { name: "endedAt" },
    },
    carId: {},
};

const initialState = getInitialStateFromConfig(config);

class LogistHistoryForm extends BookShow {
    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        if (match.params.id) {
            source.getItem(match.params).then((data) => this.setState({ data, initial: data, ...defParams }));
        } else {
            this.setState(defParams);
        }
    };

    get dropdActions() {
        if (!this.props.canEditBooks) {
            return [];
        }
        return [{ text: "Удалить", action: this.actionClose }];
    }

    apply = () => {
        const { source, match, mergeParams, back } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                this.setState({ isLoading: true, isValid: true });
                return source.apply({ carId: match.params.truckId, ...serializeReq({ ...state.data }) }).then((res) => {
                    if (res) {
                        match.params.id ? this.update(mergeParams) : back();
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    renderButton = () => {
        if (!this.props.canEditBooks) {
            return null;
        }
        const { match } = this.props;
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            <div className="panel__row panel__row--button">
                <div className={cname} onClick={this.apply}>
                    {match.params.id ? "Обновить" : "Создать"}
                </div>
            </div>
        );
    };

    renderBody = () => {
        const { config } = this.props;
        return (
            <>
                {this.renderSelect(config.logistId)}
                {this.renderDateField(config.startedAt)}
                {this.renderDateField(config.endedAt)}
                {this.renderButton()}
            </>
        );
    };
}

const ConfiguredShow = (props) => <LogistHistoryForm {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "logist-history");
